import { useAppSelector } from "@/store/store-hooks";
import { selectHasWritePermission } from "@/store/user-selectors";
import { FaroButton } from "@faro-lotv/flat-ui";
import { Box } from "@mui/material";
import type { JSX } from "react";
import { useImportDataDialog } from "./import-data-dialog-context";

/**
 * @returns Button that opens the import data dialog
 */
export function ImportDataButton(): JSX.Element | null {
  const { openDialog } = useImportDataDialog();
  const hasWritePermission = useAppSelector(selectHasWritePermission);

  // If the user does not have write permission, do not show the button.
  if (!hasWritePermission) {
    return null;
  }

  return (
    <Box
      component="div"
      sx={{
        mx: 2,
        my: 1,
      }}
    >
      <FaroButton
        aria-label="import data button"
        onClick={openDialog}
        sx={{ width: "100%" }}
      >
        Import data
      </FaroButton>
    </Box>
  );
}
